export default __webpack_public_path__ + "static/media/icon-play-plan-info.d35ba9e6.svg";